import styled, { css } from 'styled-components';
import { colors, layout } from 'src/components/base';
import {
  BodySmallText,
  H3Text,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';

const borderStyle = `1px solid  ${colors.lightTheme.base200}`;

export const DataList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;

export const Section = styled.section`
  break-inside: avoid;
`;

type ColumnProps = {
  full?: boolean;
};

export const Column = styled.div<ColumnProps>`
  box-sizing: border-box;
  padding: ${layout.measurements.spacing075} 0;
  word-wrap: break-word;

  &:nth-of-type(odd) {
    flex: 0 0 35%;
    max-width: 50%;
  }

  &:nth-of-type(even) {
    flex: 1 0 50%;
    padding-left: ${layout.measurements.spacing050};
  }

  ${p =>
    p.full &&
    css`
      width: 100%;
    `}
`;

type RowProps = {
  inline: boolean;
};

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: ${borderStyle};

  &:last-of-type {
    border-bottom: none;
  }

  ${p =>
    p.inline &&
    css`
      border-top: ${borderStyle};
      border-bottom: none;
      & > ${Column}:nth-of-type(odd) {
        padding-left: ${layout.measurements.spacing050};
      }

      & > & > ${Column}:nth-of-type(odd) {
        padding-left: ${layout.measurements.spacing100};
      }

      & > & > & > ${Column}:nth-of-type(odd) {
        padding-left: ${layout.measurements.spacing150};
      }
    `}
`;

export const Title = H3Text;

export const Byline = styled.span`
  display: block;
  color: ${p => p.theme.colors.base600};
`;

export const PropertyName = styled(BodySmallText).attrs({
  emphasis: FontEmphasis.MEDIUM,
})``;

export const PropertyValue = styled(BodySmallText)``;
